import Application from '../../Application'
import utils from '../../utils'
import ScorocodeError from '../../utils/ScorocodeError'
import { ICredentialsProvider, IProviders, IUserInfo } from '../client/Auth'
import { ApplicationCredentials } from './Credentials'

export class UserInfo implements IUserInfo {
  readonly uid: string = ''
  readonly email: string = ''
  readonly emailVerified: boolean = false
  firstName?: string
  middleName?: string
  familyName?: string
  name?: string
  gender?: string
  birthdate?: string
  zoneinfo?: string
  locale?: string
  website?: string
  createdAt?: string
  updatedAt?: string
  loggedAt?: string
  picture?: string
  profile?: {}

  constructor(params: IUserInfo) {
    utils.setProperties(this, params, ['uid', 'email', 'email_verified'])
  }
}

export interface UserParams {
  app: Application
  credentials: ApplicationCredentials
  info: UserInfo
  // metadata: {};  // todo
}

export default class User {
  private _app: Application
  private _credentials: ApplicationCredentials
  private _info: UserInfo
  // private _metadata: {};  // todo

  get credentials(): ApplicationCredentials {
    return this._credentials
  }

  get info(): UserInfo {
    return this._info
  }

  get uid(): string {
    return this._info.uid
  }

  get email(): string {
    return this._info.email
  }

  get emailVerified(): boolean {
    return this._info.emailVerified
  }

  constructor(params: UserParams) {
    this._app = params.app
    this._credentials = params.credentials
    this._info = params.info
  }

  update(): Promise<User> {
    return this._app
      .client()
      .auth.updateUser({
        idToken: this.credentials.idToken,
        user: this.info,
      })
      .then((res) => {
        this._info = new UserInfo(res.info)

        return this
      })
  }

  linkProvider(credentials: ICredentialsProvider): Promise<IProviders> {
    return this._app.client().auth.linkProvider({
      idToken: this.credentials.idToken,
      credentials,
    })
  }

  unlinkProvider(provider: string): Promise<IProviders> {
    return this._app.client().auth.unlinkProvider({
      idToken: this.credentials.idToken,
      provider,
    })
  }

  refreshCredentials(): Promise<User> {
    return this._app
      .client()
      .auth.refreshToken({
        refreshToken: this.credentials.refreshToken,
      })
      .then((res) => {
        this._credentials = new ApplicationCredentials(res)

        return this
      })
  }

  sync(): Promise<User> {
    return this._app
      .client()
      .auth.getUser({
        idToken: this.credentials.idToken,
      })
      .then((res) => {
        this._info = new UserInfo(res)

        return this
      })
  }

  realSync(
    onChange: (user: User) => void,
    onError: (error: ScorocodeError) => void
  ): void {
    // todo
    onChange(this)
  }

  delete(): Promise<User> {
    return this._app
      .client()
      .auth.deleteUser({
        idToken: this.credentials.idToken,
      })
      .then(() => this)
  }
}
